module.exports = "<div style=\"width:400px;\">\n\t<calendar-attendance selected=\"day\"></calendar-attendance>\n\t<md-button ng-click=\"accountCtrl.click()\" class=\"md-raised md-primary\">Add Class Room</md-button>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/olr-mainfe-account/index.html
 ** module id = 206
 ** module chunks = 1
 **/